import { Box } from "@mui/material";
import OrangeDot from "@assets/svgs/dots/orange-dot.svg";
import {
  addFamilyMemberButtonText,
  addFamilyMemberButtonContainer,
  dotBox,
} from "./AddFamilyMemberButtonStyles";

interface AddFamilyMemberButtonProps {
  familyMemberName: string;
  isSelected: boolean;
  hasIncompleteForm: boolean;
  onClick?: () => void;
}

export const AddFamilyMemberButton = ({
  familyMemberName,
  isSelected,
  hasIncompleteForm,
  onClick,
}: AddFamilyMemberButtonProps) => {
  return (
    <Box sx={addFamilyMemberButtonContainer(isSelected)} onClick={onClick}>
      {hasIncompleteForm && (
        <Box sx={dotBox} component="span">
          <img src={OrangeDot} alt="Family memeber chosen" />
        </Box>
      )}
      <Box component="span" sx={addFamilyMemberButtonText}>
        {familyMemberName}
      </Box>
    </Box>
  );
};
